<template>
    <div class="min-h-screen-with-header flex items-center justify-center">
        <UiComponentTypography tag="h2"> به زودی </UiComponentTypography>
    </div>
</template>

<script lang="ts" setup>
useSeoMeta({
    title: "درباره ما | شرکت رستری قهوه نرس‌لند",
    description: "آشنایی با تاریخچه، اهداف، رسالت و استانداردهای کیفی شرکت رستری قهوه نرس‌لند در تامین و برشته‌کاری بهترین دانه‌های قهوه تخصصی جهان.",
    canonical: "https://northland-co.com/about",
    ogTitle: "درباره شرکت رستری قهوه نرس‌لند",
    ogDescription: "داستان و رسالت نرس‌لند در ارائه بالاترین کیفیت قهوه تخصصی و تجاری.",
    ogType: "website",
    ogUrl: "https://northland-co.com/about",
    robots: "index, follow",
});

useSchemaOrg([
    defineBreadcrumb({
        itemListElement: [
            { name: "خانه", item: "/" },
            { name: "درباره ما", item: "https://northland-co.com/about" },
        ],
    }),
]);

defineOgImageComponent("Main", {
    title: "درباره نرس‌لند",
    description: "داستان و رسالت شرکت رستری قهوه نرس‌لند",
    path: "/about",
});
</script>

<style></style>
